import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Row, Col, Container, Form, ListGroup, Button } from "react-bootstrap";
import Icofont from "react-icofont";
import Select2 from "react-select2-wrapper";
import OwlCarousel from "react-owl-carousel3";
import ProductBox from "./ProductBox";

import CategoriesCarousel from "../common/CategoriesCarousel";
import { SearchResultsList } from "./SearchResultsList";
import { liefershops, saveSignedSession } from "../../utils";
import { getPartnerIdFromDomain, getPartnerData, isPartnerDomain } from "../../partnerDomain";

function slugify(text) {
  return (
    text
      /* .toString()   */ // Cast to string (optional)
      .normalize("NFKD") // The normalize() using NFKD method returns the Unicode Normalization Form of a given string.
      .toLowerCase() // Convert the string to lowercase letters
      /* .trim()   */ // Remove whitespace from both sides of a string (optional)
      .replace(/\s+/g, "-") // Replace spaces with -
      .replace(/[^\w\-]+/g, "") // Remove all non-word chars
      .replace(/\-\-+/g, "-")
  ); // Replace multiple - with single -
}

export const TopSearch = () => {
  const [input, setInput] = useState("");
  const [results, setResults] = useState([]); 
  

  const fetchData = (value) => {
    fetch(liefershops("api/v1/plz/"))
      .then((response) => response.json())
      .then((json) => {
        let newValue = value.trim();
        // Extract numeric part and text part from input
        const numericPart = newValue.replace(/[^0-9]/g, "");
        const textPart = newValue.replace(/[0-9]/g, "").trim();

        const results = json.filter((ort) => {
          if (!ort) return false;
          // If input is purely numeric, search by PLZ
          if (/^[0-9]+$/.test(newValue)) {
            return ort.postleitzahl && ort.postleitzahl.includes(newValue);
          }
          // If input has both numbers and text (e.g. "12524 Berlin"), match both
          if (numericPart && textPart) {
            const plzMatch = ort.postleitzahl && ort.postleitzahl.includes(numericPart);
            const bezirkMatch = ort.bezirk && ort.bezirk.toLowerCase().includes(slugify(textPart));
            return plzMatch && bezirkMatch;
          }
          // Pure text search by city/district
          const slugified = slugify(newValue);
          return slugified && ort.bezirk && ort.bezirk.toLowerCase().includes(slugified);
        });
        setResults(results);
      })
      .catch((err) => console.error("PLZ fetch error:", err));
  };

  const handleChange = (value) => {
    setInput(value);
    if (value.trim().length >= 3) {
      fetchData(value);
    } else {
      setResults([]);
    }
  };

  const navigateAfterSearch = async (plz, bezirk) => {
    const partnerId = getPartnerIdFromDomain();
    // Keep localStorage["plz"] for older code paths that still read it; the
    // authoritative value lives in the server-signed cookie set below.
    localStorage.setItem("plz", plz);

    if (partnerId) {
      // Standalone partner domain. Persist the partner+plz in the signed
      // cookie so delivery validation can run server-side, then route to the
      // partner's clean URL once we know its slug.
      try {
        const partnerResp = await fetch(liefershops(`api/v1/partner/${partnerId}/`));
        if (partnerResp.ok) {
          const partner = await partnerResp.json();
          await saveSignedSession({ plz, partner_slug: partner.slug, partner_id: partner.id });
          if (partner.slug) {
            window.location.href = `/${partner.slug}/${plz}`;
            return;
          }
        }
      } catch (e) {
        // fall through to legacy URL
      }
      await saveSignedSession({ plz, partner_id: partnerId });
      window.location.href = `/detail?id=${partnerId}`;
      return;
    }

    await saveSignedSession({ plz });
    window.location.href = `/listing?plz=${plz}&ort=${bezirk || ''}`;
  };

  const handleSubmit = async () => {
    if (results.length > 0) {
      const first = results[0];
      await navigateAfterSearch(first.postleitzahl, first.bezirk);
      return;
    }
    const trimmed = input.trim();
    const numericPart = trimmed.replace(/[^0-9]/g, "");
    if (numericPart.length === 5) {
      await navigateAfterSearch(numericPart, "");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }
  };

  const formControllComponent = (
    <Form.Control
      type="search"
      placeholder="Postleitzahl oder Ort eingeben"
      size="lg"
      onChange={(e) => handleChange(e.target.value)}
      onKeyDown={handleKeyDown}
      value={input}
      enterKeyHint="search"
    />
  );

  return (
    <section
      className="pt-5 pb-5 homepage-search-block position-relative"
      style={{ backgroundColor: "rgb(109, 0, 0)" }}
    >
      {" "}
      {/* <div className="banner-overlay">пплплплплл</div> */}
      <Container>
        <Row className="d-flex align-items-center">
          {/* <Col md={4}>
            <div className="osahan-slider pl-4 pt-3">
              <OwlCarousel
                nav
                loop
                {...options2}
                className="homepage-ad owl-theme"
              >
                <div className="item">
                  <ProductBox
                    image="img/slider1.png"
                    imageClass="img-fluid rounded"
                    imageAlt="carousel"
                    linkUrl="listing"
                  />
                </div>
              </OwlCarousel>
            </div>
          </Col> */}
          <Col md={4}>
            <div className="osahan-slider pl-4 pt-3">
             
                <div className="item">
                  <ProductBox
                    image="img/slider1.png"
                    imageClass="img-fluid rounded"
                    imageAlt="Liefershops Hamburger"
                    linkUrl="listing"
                  />
                </div>
              
            </div>
          </Col>
          <Col md={8} className="mx-auto">
            <div className="homepage-search-title">
              {isPartnerDomain() && getPartnerData() ? (
                <>
                  <h1 className="mb-2 font-weight-normal whitetext">
                    <span className="font-weight-bold">
                      Willkommen bei {getPartnerData().name}!
                    </span>
                  </h1>
                  <h5 className="mb-4 font-weight-normal whitetext">
                    Geben Sie Ihre Postleitzahl ein, um zu bestellen
                  </h5>
                </>
              ) : (
                <>
                  <h1 className="mb-2 font-weight-normal whitetext">
                    <span className="font-weight-bold">
                    Bestellen Sie jetzt Ihr Lieblingsessen
                    </span>{" "}<br/>
                    in Deutschland!
                  </h1>
                  <h5 className="mb-4 font-weight-normal whitetext">
                  Wohin soll es geliefert werden?
                  </h5>
                </>
              )}
            </div>
            <div className="homepage-search-form">
              <Form className="form-noborder" onSubmit={(e) => {e.preventDefault(); handleSubmit();}}>
                <div className="form-row">
                  <Form.Group className="col-lg-10 col-md-10 col-sm-12">
                    {formControllComponent}
                    <SearchResultsList className="col-lg-10 col-md-10 col-sm-12" results={results} setInputValue={setInput}/>
                  </Form.Group>
                  <Form.Group className="col-lg-2 col-md-2 col-sm-12">
                    <Button variant="danger" size="lg" type="submit" className="w-100">
                      <Icofont icon="search" /> Suchen
                    </Button>
                  </Form.Group>
                </div>
              </Form>
            </div>
          </Col>

          {/* <Container>
            <h4 className="mt-4 text-shadow font-weight-normal">
              Restaurant Kategorien
            </h4>
            <CategoriesCarousel />
          </Container> */}
        </Row>
      </Container>
    </section>
  );
};

const options2 = {
  responsive: {
    0: {
      items: 1,
    },
    764: {
      items: 1,
    },
    765: {
      items: 1,
    },
    1200: {
      items: 1,
    },
  },
  lazyLoad: true,
  loop: true,
  autoplay: true,
  autoplaySpeed: 1000,
  dots: false,
  autoplayTimeout: 2000,
  nav: false,
  navText: [
    "<i class='fa fa-chevron-left'></i>",
    "<i class='fa fa-chevron-right'></i>",
  ],
  autoplayHoverPause: true,
  animateOut: false,
  animateIn: false,
};

export default TopSearch;
